import BaseApi from "./BaseApi";

export default class SupplierService extends BaseApi {

    constructor(){
        super();
    }

    async list()
    {
        return this.http.get(`${this.baseUrl}/suppliers`)
        .catch(this.handleErrorResponse);
    }

    async get(id)
    {
        return this.http.get(`${this.baseUrl}/suppliers/${id}`)
        .catch(this.handleErrorResponse);
    }

   

    async store(data)
    {
        return this.http.post(`${this.baseUrl}/suppliers`, data)
        .catch(this.handleErrorResponse);
    }

    async update(id, data)
    {
        return this.http.put(`${this.baseUrl}/suppliers/${id}`, data)
        .catch(this.handleErrorResponse);
    }

    async delete(id)
    {
        return this.http.delete(`${this.baseUrl}/suppliers/${id}`)
        .catch(this.handleErrorResponse);
    }


    async getSelect(){
        return this.http.get(`${this.baseUrl}/suppliers/gets/getSuppliers`)
        .catch(this.handleErrorResponse);
    }
}